export function InfiniteProgressBarIndicator() {
  return (
    <div className="w-full">
      <div className="h-1.5 w-full bg-primary bg-opacity-15 overflow-hidden rounded-full">
        <div className="animate-progress w-full h-full bg-primary origin-left-right" />
      </div>
    </div>
  );
}
